module.exports = __webpack_public_path__ + "img/ad4x.552f45cf.png";